import { useState, useEffect, useRef, useMemo } from "react";
import SectionHead from "./SectionHead";
import img1 from "./images/img1.jpg";
import img2 from "./images/img2.jpg";
import img3 from "./images/img3.jpg";
import img4 from "./images/img4.jpg";
import img5 from "./images/img5.jpg";
import img6 from "./images/img6.jpg";
import img7 from "./images/img7.jpg";
import img8 from "./images/img8.jpg";
import img9 from "./images/img9.jpg";
import img10 from "./images/img10.jpg";
import img11 from "./images/img11.jpg";
import video1 from "./images/video1.mp4";
import video2 from "./images/video2.mp4";

// ✏️ Faqat shu massivni to'ldiring
const galleryImages = [
  { src: img1, title: "Yakuniy imtihon", desc: "Barcha raqamli qurilmalar topshirildi. Sof bilimni sinash — dekabr oyidagi yakuniy baholash sessiyasi.", date: "Dekabr 2025" },
  { src: img2, title: "Imtihon sessiyasi", desc: "Tinglovchilar mustaqil ravishda yozma ishni bajarayapti. Intizom va bilimning uyg'unligi.", date: "Dekabr 2025" },
  { src: img3, title: "iOS ilovasi loyihasi", desc: "Amaliy modul doirasida tinglovchilar iOS launcher ilovasini noldan ishlab chiqdi. Nazariyadan amaliyotga.", date: "Dekabr 2025" },
  { src: img4, title: "Dasturlash kursi", desc: "Fevral oyi mashg'ulotlari — tizimli yondashuv va amaliy topshiriqlar orqali ko'nikmalarni mustahkamlash.", date: "Fevral 2025" },
  { src: img5, title: "Amaliy mashg'ulotlar", desc: "Mart oyidagi intensiv mashg'ulot. Tinglovchilar nazorat ostida mustaqil loyiha vazifalarini hal etmoqda.", date: "Mart 2025" },
  { src: img6, title: "CaEX · AI Health", desc: "26 mart — CaEX platformasida o'tkazilgan AI Health yo'nalishidagi xalqaro hackathonda mentor va tinglovchilar bilan ishtirok etildi.", date: "26 Mart 2025" },
  { src: img7, title: "AIFU · Finalist", desc: "23 fevral — AIFU hackathonida 300 nafar ishtirokchi orasidan top-40 finalistlar qatoriga kirish.", date: "23 Fevral 2025" },
  { src: img8, title: "Ai500 · Top-40", desc: "13 dekabr — Ai500 musobaqasida AiTECH jamoasi tarkibida 1 300 ishtirokchi orasidan faxrli top-40 o'rinni egalladi.", date: "13 Dekabr 2025" },
  { src: img9, title: "AiTECH · Ai500", desc: "Ai500 finalida AiTECH jamoasining natijasi. 1 300 nafar ishtirokchiga nisbatan yuqori saralash bosqichini muvaffaqiyatli yakunlash.", date: "13 Dekabr 2025" },
  { src: img10, title: "CaEX · AiHealth", desc: "CaEX platformasida o'tkazilgan AI Health yo'nalishidagi xalqaro hackathonda mentor va tinglovchilar bilan ishtirok etildi.", date: "26 Mart 2026" },
  { src: img11, title: "Dars jarayoni", desc: "JavaScript yordamida cursorni harakatlantirish.", date: "27 mart 2026" },
  
  
];

const galleryVideos = [
  { src: video1, title: "AIFU Hackathon", desc: "23 fevral — AIFU hackathonidagi jonli lahzalar." },
  { src: video2, title: "AIFU Hackathon", desc: "Jamoa ruhi va taqdimot jarayonidan kadrlar." },
];

// Desktop: 3 ustunga bo'lish
function buildColumns(images) {
  return [0, 1, 2].map((colIdx) => {
    const base = [];
    for (let i = colIdx; i < images.length; i += 3) base.push(i);
    while (base.length < 4) base.push(...base);
    return base.map(i => ({ ...images[i % images.length], originalIndex: i % images.length }));
  });
}

const COL_DIRS = [1, -1, 1];
const COL_SPEED = [0.5, 0.35, 0.6];

// ─── Infinite Column (vertikal) ──────────────────────────────────────────────
function InfiniteColumn({ items, dir, speed, onOpen }) {
  const trackRef = useRef(null);
  const offset = useRef(0);
  const rafRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    if (dir === -1) offset.current = track.scrollHeight / 2;

    const tick = () => {
      offset.current += speed * dir;
      const half = track.scrollHeight / 2;
      if (half <= 0) { rafRef.current = requestAnimationFrame(tick); return; }
      if (dir === 1 && offset.current >= half) offset.current -= half;
      if (dir === -1 && offset.current <= 0) offset.current += half;
      track.style.transform = `translateY(${-offset.current}px)`;
      rafRef.current = requestAnimationFrame(tick);
    };

    const t = setTimeout(() => { rafRef.current = requestAnimationFrame(tick); }, 50);
    return () => { clearTimeout(t); cancelAnimationFrame(rafRef.current); };
  }, [dir, speed]);

  const tripled = [...items, ...items, ...items];

  return (
    <div style={{ overflow: "hidden", height: "100%" }}>
      <div ref={trackRef} style={{ display: "flex", flexDirection: "column", gap: 10, willChange: "transform" }}>
        {tripled.map((item, i) => (
          <div
            key={i}
            onClick={() => onOpen(item.originalIndex)}
            style={{ position: "relative", borderRadius: 12, overflow: "hidden", flexShrink: 0, cursor: "pointer", border: "1.5px solid #ede9fe" }}
            onMouseEnter={e => {
              e.currentTarget.querySelector("img").style.transform = "scale(1.06)";
              e.currentTarget.querySelector(".hov").style.opacity = "1";
            }}
            onMouseLeave={e => {
              e.currentTarget.querySelector("img").style.transform = "scale(1)";
              e.currentTarget.querySelector(".hov").style.opacity = "0";
            }}
          >
            <img src={item.src} alt={item.title} style={{ width: "100%", display: "block", objectFit: "cover", transition: "transform .5s ease" }} />
            <div className="hov" style={{ position: "absolute", inset: 0, background: "linear-gradient(0deg,rgba(15,10,30,.85) 0%,transparent 55%)", display: "flex", flexDirection: "column", justifyContent: "flex-end", padding: "12px 14px", opacity: 0, transition: "opacity .3s", pointerEvents: "none" }}>
              <p style={{ color: "#fff", fontSize: 12, fontWeight: 700, margin: 0, lineHeight: 1.3 }}>{item.title}</p>
              <p style={{ color: "#c4b5fd", fontSize: 11, margin: "3px 0 0" }}>{item.date}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── Mobile: Instagram-uslubidagi swipe karusel ─────────────────────────────
function shuffleArray(arr) {
  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}

function MobileRow({ items, onOpen }) {
  // Har safar komponent yuklanganda tartib aralashtiriladi — birinchi rasm ham har safar boshqa bo'ladi
  const shuffled = useMemo(() => shuffleArray(items), [items]);
  const trackRef = useRef(null);
  const [active, setActive] = useState(0);
  const total = shuffled.length;
  const rafRef = useRef(null);

  const computeActive = () => {
    const track = trackRef.current;
    if (!track || !track.children.length) return;
    const cardWidth = track.children[0].offsetWidth;
    const gap = 14;
    const idx = Math.round(track.scrollLeft / (cardWidth + gap));
    setActive(Math.max(0, Math.min(total - 1, idx)));
  };

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;
    const onScroll = () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
      rafRef.current = requestAnimationFrame(computeActive);
    };
    track.addEventListener("scroll", onScroll, { passive: true });
    return () => track.removeEventListener("scroll", onScroll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [total]);

  const scrollToIndex = (i) => {
    const track = trackRef.current;
    const card = track?.children[i];
    if (card) card.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
  };

  return (
    <div>
      <div
        ref={trackRef}
        className="no-scrollbar"
        style={{
          display: "flex",
          gap: 14,
          overflowX: "auto",
          scrollSnapType: "x mandatory",
          WebkitOverflowScrolling: "touch",
          paddingLeft: "9vw",
          paddingRight: "9vw",
        }}
      >
        {shuffled.map((item, i) => {
          const isActive = i === active;
          return (
            <div
              key={i}
              onClick={() => (isActive ? onOpen(item.originalIndex) : scrollToIndex(i))}
              style={{
                position: "relative",
                flexShrink: 0,
                width: "82vw",
                maxWidth: 360,
                aspectRatio: "3 / 4",
                borderRadius: 22,
                overflow: "hidden",
                scrollSnapAlign: "center",
                border: isActive ? "1.5px solid #c4b5fd" : "1.5px solid #ede9fe",
                boxShadow: isActive ? "0 12px 30px -10px rgba(124,58,237,.35)" : "none",
                transform: isActive ? "scale(1)" : "scale(0.9)",
                opacity: isActive ? 1 : 0.5,
                transition: "transform .35s cubic-bezier(.22,1,.36,1), opacity .35s ease, box-shadow .35s ease",
                cursor: "pointer",
              }}
            >
              <img src={item.src} alt={item.title} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
              <div style={{ position: "absolute", inset: 0, background: "linear-gradient(0deg,rgba(15,10,30,.85) 0%,rgba(15,10,30,0) 45%)" }} />
              <span style={{ position: "absolute", top: 12, right: 12, fontSize: 11, fontWeight: 700, color: "#fff", background: "rgba(0,0,0,.35)", padding: "4px 10px", borderRadius: 20, backdropFilter: "blur(4px)" }}>
                {i + 1} / {total}
              </span>
              <div style={{ position: "absolute", left: 0, right: 0, bottom: 0, padding: "18px 18px" }}>
                <p style={{ color: "#fff", fontSize: 15, fontWeight: 600, margin: 0, lineHeight: 1.3 }}>{item.title}</p>
                <p style={{ color: "#c4b5fd", fontSize: 12, margin: "4px 0 0", fontWeight: 400 }}>{item.date}</p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Progress dots — bosilsa mos rasmga sirg'aladi */}
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 6, marginTop: 18 }}>
        {shuffled.map((_, i) => (
          <button
            key={i}
            onClick={() => scrollToIndex(i)}
            aria-label={`${i + 1}-rasmga o'tish`}
            style={{
              width: i === active ? 20 : 6,
              height: 6,
              borderRadius: 4,
              background: i === active ? "#7c3aed" : "#ede9fe",
              border: "none",
              padding: 0,
              transition: "width .3s ease, background .3s ease",
              cursor: "pointer",
            }}
          />
        ))}
      </div>

      <style>{`.no-scrollbar::-webkit-scrollbar{display:none}.no-scrollbar{scrollbar-width:none}`}</style>
    </div>
  );
}

// ─── Lightbox ────────────────────────────────────────────────────────────────
function Lightbox({ item, index, total, onClose, onPrev, onNext }) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  useEffect(() => {
    const fn = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowLeft") onPrev();
      if (e.key === "ArrowRight") onNext();
    };
    window.addEventListener("keydown", fn);
    return () => window.removeEventListener("keydown", fn);
  }, [onClose, onPrev, onNext]);

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 9999, background: "rgba(10,6,24,.82)", backdropFilter: "blur(14px)", WebkitBackdropFilter: "blur(14px)", display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div onClick={e => e.stopPropagation()} style={{ position: "relative", width: "100%", maxWidth: 720, animation: "lbPop .28s cubic-bezier(.22,1,.36,1)" }}>
        <img src={item.src} alt={item.title} style={{ width: "100%", maxHeight: "55vh", objectFit: "cover", borderRadius: "16px 16px 0 0", display: "block" }} />
        <div style={{ background: "#fff", borderRadius: "0 0 16px 16px", padding: "16px 20px 20px", border: "1.5px solid #ede9fe", borderTop: "none" }}>
          <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 10 }}>
            <h3 style={{ fontSize: 15, fontWeight: 800, color: "#1e1040", lineHeight: 1.3, margin: 0 }}>{item.title}</h3>
            <span style={{ fontSize: 11, fontWeight: 700, color: "#7c3aed", background: "#f5f3ff", borderRadius: 8, padding: "4px 10px", whiteSpace: "nowrap", marginTop: 2 }}>{item.date}</span>
          </div>
          <p style={{ fontSize: 13, color: "#64748b", marginTop: 8, lineHeight: 1.7 }}>{item.desc}</p>
          <p style={{ fontSize: 12, color: "#c4b5fd", marginTop: 10, textAlign: "center", fontWeight: 600 }}>{index + 1} / {total}</p>
        </div>

        {/* ← → faqat desktop */}
        <button onClick={onPrev} style={{ position: "absolute", top: "40%", left: -50, width: 38, height: 38, borderRadius: "50%", background: "rgba(255,255,255,.15)", border: "1.5px solid rgba(255,255,255,.28)", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
          <svg width="14" height="14" fill="none" stroke="#fff" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <button onClick={onNext} style={{ position: "absolute", top: "40%", right: -50, width: 38, height: 38, borderRadius: "50%", background: "rgba(255,255,255,.15)", border: "1.5px solid rgba(255,255,255,.28)", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
          <svg width="14" height="14" fill="none" stroke="#fff" strokeWidth="2.5" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6" /></svg>
        </button>
      </div>

      <button onClick={onClose} style={{ position: "fixed", top: 16, right: 16, width: 36, height: 36, borderRadius: "50%", background: "rgba(255,255,255,.13)", border: "1.5px solid rgba(255,255,255,.22)", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer" }}>
        <svg width="14" height="14" fill="none" stroke="#fff" strokeWidth="2.5" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>
      </button>
      <style>{`@keyframes lbPop{from{opacity:0;transform:scale(.93)}to{opacity:1;transform:scale(1)}}`}</style>
    </div>
  );
}

// ─── Gallery ─────────────────────────────────────────────────────────────────
export default function Gallery() {
  const [tab, setTab] = useState(0);
  const [lightbox, setLightbox] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  const columns = buildColumns(galleryImages);

  // Mobile uchun barcha rasmlar bitta qatorda
  const mobileItems = galleryImages.map((img, i) => ({ ...img, originalIndex: i }));

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <SectionHead
          eyebrow="Fotosessiya"
          title="Dars jarayonidan lavhalar"
          sub="Jonli muhit, amaliy mashg'ulotlar va jamoamiz bilan tanishing."
        />

        <div className="flex justify-center gap-2 mb-10">
          {["Rasmlar", "Videolar"].map((label, i) => (
            <button key={i} onClick={() => setTab(i)} className="px-5 py-2 rounded-xl text-sm font-bold transition-all"
              style={{ background: tab === i ? "#7c3aed" : "#f5f3ff", color: tab === i ? "#fff" : "#7c3aed", border: "1.5px solid #ede9fe" }}>
              {label}
            </button>
          ))}
        </div>

        {tab === 0 && (
          isMobile ? (
            // ── Mobile: bitta gorizontal qator ──
            <div style={{ position: "relative" }}>
              <MobileRow items={mobileItems} onOpen={setLightbox} />
            </div>
          ) : (
            // ── Desktop: 3 ta vertikal ustun ──
            <div style={{ position: "relative" }}>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10, height: 580, overflow: "hidden", borderRadius: 16 }}>
                {columns.map((colItems, ci) => (
                  <InfiniteColumn key={ci} items={colItems} dir={COL_DIRS[ci]} speed={COL_SPEED[ci]} onOpen={setLightbox} />
                ))}
              </div>
              {/* Tepa fade — kamroq (60px) */}
              <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 60, background: "linear-gradient(to bottom,#ffffff 0%,rgba(255,255,255,0) 100%)", pointerEvents: "none", zIndex: 10 }} />
              {/* Past fade — kamroq (60px) */}
              <div style={{ position: "absolute", bottom: 0, left: 0, right: 0, height: 60, background: "linear-gradient(to top,#ffffff 0%,rgba(255,255,255,0) 100%)", pointerEvents: "none", zIndex: 10 }} />
            </div>
          )
        )}

        {tab === 1 && (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
            {galleryVideos.map((v, i) => (
              <div key={i} className="rounded-2xl overflow-hidden" style={{ border: "1.5px solid #ede9fe", background: "#0f0a1e" }}>
                <video src={v.src} controls className="w-full" style={{ display: "block", maxHeight: 260, objectFit: "cover" }} />
                <div style={{ padding: "12px 16px" }}>
                  <p style={{ color: "#fff", fontSize: 13, fontWeight: 700, margin: 0 }}>{v.title}</p>
                  <p style={{ color: "#a78bfa", fontSize: 12, margin: "4px 0 0" }}>{v.desc}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {lightbox !== null && (
        <Lightbox
          item={galleryImages[lightbox]}
          index={lightbox}
          total={galleryImages.length}
          onClose={() => setLightbox(null)}
          onPrev={() => setLightbox(i => (i - 1 + galleryImages.length) % galleryImages.length)}
          onNext={() => setLightbox(i => (i + 1) % galleryImages.length)}
        />
      )}
    </section>
  );
}